import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Spin,
} from 'antd';
import { onError } from 'utils/handlers';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import NumericInput from 'components/NumericInput';
import { DATETIME_FRONTEND_FORMAT } from 'utils/formatValues';
import {
  deleteConceptoDeMulta,
  getConceptosDeMultas,
  patchConceptoDeMultas,
  postConceptoDeMultas,
} from 'api/recaudacion/conceptosDeMultas';
import { getTiposDeMotivos } from 'api/recaudacion';
// import { getTiposDeCargos } from 'api/recaudacion/tiposDeCargo';

export const modelCrud = 'conceptodemulta';

const ConceptosDeMultas = ({ multa, permission }) => {
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [tiposDeMotivos, setTiposDeMotivos] = useState([]);
  // const [tipoDeCargoTemp, setTipoDeCargoTemp] = useState({ results: [] });
  // const tipoDeCargo = useRef({ results: [] });

  const fetchData = async () => {
    setLoading(true);
    if (multa) {
      const _data = await getConceptosDeMultas({ multa });
      setData(_data);
    }
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      const [
        _data,
        _motivos,
      ] = await Promise.all([
        getConceptosDeMultas({ multa }),
        getTiposDeMotivos(),
      ]);
      if (mounted) {
        setData(_data);
        setTiposDeMotivos(_motivos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onClickEdit = () => {
    setVisible(true);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      values.multa = multa;
      const [key] = selectedRowKeys;
      const saved = await (key ? patchConceptoDeMultas(key, values)
        : postConceptoDeMultas(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteConceptoDeMulta(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave_de_tipo_de_concepto',
      key: 'clave_de_tipo_de_concepto',
      width: 150,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion_tipo_de_concepto',
      key: 'descripcion_tipo_de_concepto',
      width: 200,
    },
  ];

  const rules = {
    required: [
      { required: true },
    ],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible ? (
          <Table
            cols={columns}
            mobileColumns={[columns[0], columns[1]]}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            rowKey="id"
            pagination={false}
            permission={permission}
            hasAllViewPermission
          />
        ) : (
          <Card
            bordered={false}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
              />
            )}
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Concepto`}
          >
            <Form
              name="general"
              layout="vertical"
              form={form}
              onFinish={() => onFinish()}
              scrollToFirstError
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Clave"
                    rules={rules.required}
                    name="clave_de_tipo_de_concepto"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Descripcion"
                    rules={rules.required}
                    name="descripcion_tipo_de_concepto"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Tipo de motivo"
                    rules={rules.required}
                    name="tipo_de_motivo"
                    hasFeedback
                  >
                    <Select dataSource={tiposDeMotivos} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="¿Está activo?"
                    name="activo"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    name="importe"
                    label="importe"
                    required
                    decimal
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    name="importe_en_moneda"
                    label="importe en moneda"
                    required
                    decimal
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha"
                    label="Fecha"
                  >
                    <DatePicker
                      placeholder=""
                      format={DATETIME_FRONTEND_FORMAT}
                      showTime
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_final"
                    label="Fecha Final"
                  >
                    <DatePicker
                      placeholder=""
                      format={DATETIME_FRONTEND_FORMAT}
                      showTime
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={16}>
                  <Form.Item
                    name="notas"
                    label="Notas"
                  >
                    <Input.TextArea autoSize={{ minRows: 3, maxRows: 3 }} allowClear />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_cargo"
                    label="Tipo de Cargo"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      dataSource={tipoDeCargoTemp.results?.length
                        ? tipoDeCargoTemp : tipoDeCargo.current}
                      usingExternalDataSource={Boolean(tipoDeCargoTemp.results?.length)}
                      labelProp="descripcion"
                      onClear={() => {
                        form.resetFields(['tipo_de_cargo']);
                        setTipoDeCargoTemp({ results: [] });
                      }}
                      pagination={{
                        getter: getTiposDeCargos,
                        setter: (dataSource) => {
                          tipoDeCargo.current = dataSource;
                        },
                        config: { auto: true, qName: 'descripcion' },
                      }}
                    />
                  </Form.Item>
                </Col> */}
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="Concepto de Multa"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

ConceptosDeMultas.propTypes = {
  multa: PropTypes.number,
  permission: PropTypes.shape({
    add: PropTypes.bool.isRequired,
    authorize: PropTypes.bool.isRequired,
    cancel: PropTypes.bool.isRequired,
    change: PropTypes.bool.isRequired,
    delete: PropTypes.bool.isRequired,
    export: PropTypes.bool.isRequired,
    import: PropTypes.bool.isRequired,
    sync: PropTypes.bool.isRequired,
    view: PropTypes.bool.isRequired,
  }).isRequired,
};

ConceptosDeMultas.defaultProps = {
  multa: null,
};

export default ConceptosDeMultas;
